import { toCurrency } from 'shared/format-utils'

export interface BalanceCardForecast {
  value: string
  text: string
  route: string
}

const FORECAST_ROUTE = '/cofrinhos/previsao-rendimento'

export function getBalanceCardForecast({
  isEnabled,
  returnAmount,
  query
}: {
  isEnabled: boolean
  returnAmount?: number
  query: string
}): BalanceCardForecast | undefined {
  if (!isEnabled || !returnAmount) return undefined

  return {
    value: `+ ${toCurrency(returnAmount)}`,
    text: ' previsto nos próximos 30 dias',
    route: `${FORECAST_ROUTE}${query}`
  }
}
